/**
 * Flames Army — Wishlist
 * Pasos 2 y 3: interfaz del corazón + contador del header.
 *
 * Conecta los botones `.wishlist-heart` y el contador del header con el
 * core de datos (wishlist.js). Debe cargarse DESPUÉS de wishlist.js.
 *
 * Tres cosas resuelve este archivo:
 *   1. El click, con delegación en document: funciona también en los
 *      corazones que aparezcan después (filtros, paginación, carruseles).
 *   2. Intercepta el click en fase de captura, para que tocar el corazón
 *      no abra el producto a través del <a> que cubre toda la card.
 *   3. Repinta el estado cuando el tema recarga secciones por AJAX.
 */

(function () {
  'use strict';

  if (!window.Wishlist) {
    console.warn('[Wishlist] wishlist.js no está cargado. Revisá el orden de los scripts en theme.liquid.');
    return;
  }

  var SELECTOR = '.wishlist-heart';
  var LABEL_ADD = 'Agregar a la Wishlist';
  var LABEL_REMOVE = 'Quitar de la Wishlist';

  /* ------------------------------------------------------------------
   * Corazones
   * ------------------------------------------------------------------ */

  function paint(button) {
    var id = button.getAttribute('data-wishlist-id');
    if (!id) return;

    var saved = window.Wishlist.has(id);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.setAttribute('aria-label', saved ? LABEL_REMOVE : LABEL_ADD);
  }

  function paintAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      paint(buttons[i]);
    }
  }

  /* ------------------------------------------------------------------
   * Contador del header
   * ------------------------------------------------------------------ */

  var lastCount = null;

  function paintCount(animate) {
    var count = window.Wishlist.count();
    var changed = lastCount !== null && lastCount !== count;
    lastCount = count;

    var links = document.querySelectorAll('[data-wishlist-link]');

    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var bubble = link.querySelector('[data-wishlist-bubble]');
      var text = link.querySelector('[data-wishlist-count]');

      var icon = link.querySelector('[data-wishlist-icon]');
      link.classList.toggle('header-actions__wishlist--has-items', count > 0);
      if (icon) icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);

      link.setAttribute(
        'aria-label',
        count > 0
          ? 'Wishlist, ' + count + (count === 1 ? ' producto guardado' : ' productos guardados')
          : 'Wishlist'
      );

      if (text) text.textContent = count > 99 ? '99+' : String(count);
      if (!bubble) continue;

      if (count > 0) {
        bubble.removeAttribute('hidden');
      } else {
        bubble.setAttribute('hidden', '');
      }

      if (animate && changed && count > 0) {
        bubble.classList.remove('wishlist-bubble--animating');
        void bubble.offsetWidth;
        bubble.classList.add('wishlist-bubble--animating');
      }
    }
  }

  /* ------------------------------------------------------------------
   * Click — captura y delegación
   * ------------------------------------------------------------------ */

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest ? event.target.closest(SELECTOR) : null;
      if (!button) return;

      // Cortamos acá: ni el <a> de la card ni los handlers del tema se enteran.
      event.preventDefault();
      event.stopPropagation();

      window.Wishlist.toggle({
        id: button.getAttribute('data-wishlist-id'),
        variantId: button.getAttribute('data-wishlist-variant'),
        handle: button.getAttribute('data-wishlist-handle')
      });

      // Reinicia la animación aunque se haga click varias veces seguidas.
      button.classList.remove('wishlist-heart--pop');
      void button.offsetWidth;
      button.classList.add('wishlist-heart--pop');
    },
    true // fase de captura
  );

  /* ------------------------------------------------------------------
   * Sincronización
   * ------------------------------------------------------------------ */

  // Cualquier cambio en la lista repinta todo: el mismo producto puede
  // estar en varias cards a la vez, y el contador siempre acompaña.
  document.addEventListener(window.Wishlist.EVENT, function () {
    paintAll();
    paintCount(true);
  });

  // Cards y header que llegan por AJAX (filtros, paginación, carruseles).
  function watchForNewCards() {
    if (!window.MutationObserver || !document.body) return;

    var pending = null;

    var observer = new MutationObserver(function (mutations) {
      var needsPaint = false;

      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;

        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;

          if (node.matches && node.matches(SELECTOR)) {
            paint(node);
            continue;
          }

          if (
            node.querySelector &&
            (node.querySelector(SELECTOR) || node.querySelector('[data-wishlist-link]'))
          ) {
            needsPaint = true;
          }
        }
      }

      if (!needsPaint) return;

      // Agrupamos: un filtro puede insertar decenas de cards de golpe.
      clearTimeout(pending);
      pending = setTimeout(function () {
        paintAll();
        paintCount(false);
      }, 0);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    paintAll();
    paintCount(false);
    watchForNewCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();